<h1 class="number">{{current | number }}</h1>
<p class="title">{{title}}</p>
